import type { TNavItemConfig, TNavKey } from "@/types";

export const navItemsConfig: Record<TNavKey, TNavItemConfig> = {
  menu: {
    key: "menu",
    type: "link",
    label: "Menu",
    path: "/me-qr/:branchId/:typeMenu/:menuId",
    activePath: "/me-qr/:branchId/:typeMenu",
    iconKey: "book",
  },
  about: {
    key: "about",
    type: "link",
    label: "About us",
    path: "/menu/:menuId/:branchId/:typeMenu/about-us",
    activePath: "/me-qr/:branchId/:typeMenu/about-us",
    iconKey: "info",
  },
  selected: {
    key: "selected",
    type: "action",
    label: "Selected",
    iconKey: "bookmark",
    actionId: "selected",
  },
  search: {
    key: "search",
    type: "link",
    label: "Search",
    path: "/menu/:menuId/:branchId/:typeMenu/search",
    activePath: "/me-qr/:branchId/:typeMenu/search",
    iconKey: "search",
  },
  scrollTop: {
    key: "scrollTop",
    type: "action",
    label: "To top",
    iconKey: "up",
    actionId: "scrollTop",
  },
};
